import { render, staticRenderFns } from "./QrReader.vue?vue&type=template&id=a58c4864&scoped=true"
import script from "./QrReader.vue?vue&type=script&lang=js"
export * from "./QrReader.vue?vue&type=script&lang=js"
import style0 from "./QrReader.vue?vue&type=style&index=0&id=a58c4864&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a58c4864",
  null
  
)

export default component.exports